export const EXPAND_OPTIONS = {
  expand: true,
  includeHeaders: true,
  includeOutliers: false,
};
